import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
// import { ReactQueryDevtools } from "react-query/devtools";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import { StoreProvider } from "./store";
import ja_JP from "antd/lib/locale-provider/ja_JP";
import "./index.scss";
import { FontSizeProvider } from "./components/FontSizeSetting";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 1000,
      cacheTime: 5 * 1000,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StoreProvider>
    <ConfigProvider locale={ja_JP}>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <FontSizeProvider>
            <App />
          </FontSizeProvider>
        </ErrorBoundary>
        {/*<ReactQueryDevtools initialIsOpen={false} position="bottom-right" />*/}
      </QueryClientProvider>
    </ConfigProvider>
  </StoreProvider>
);

reportWebVitals();
